export default __webpack_public_path__ + "static/media/tennis_banner.4b225cd8.png";